import React, { useState, useEffect } from 'react';
import './AddNote.css';
import { useLocation, useNavigate } from "react-router-dom";
import { UpdEvent } from "../../../../context/Slice/EventManagementSlice";
import { useDispatch } from "react-redux";
import { Button } from '@mui/material';

const AddNote = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { selectedEvent } = location.state || {};
    const dispatch = useDispatch();
    const [title, setTitle] = useState('');
    const [note, setNote] = useState('');
    const [eventNotes, setEventNotes] = useState([]);

    useEffect(() => {
        if (!selectedEvent) {
            console.error("No event data received in AddNote component.");
            navigate(-1);  // Redirect if no data is received
        } else {
            setEventNotes(selectedEvent.Event_Notes || []); // Initialize notes from selectedEvent
        }
    }, [selectedEvent, navigate]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const newNote = { title, note };

        // Add the new note to the existing notes array
        const updatedNotes = [...eventNotes, newNote];

        // Update local state to reflect the new notes
        setEventNotes(updatedNotes);

        const updatedEventData = {
            ...selectedEvent,
            Event_Notes: updatedNotes,
        };

        // Dispatch the action to update the event in the backend
        dispatch(UpdEvent({ id: selectedEvent.id, updatedEventData }));

        // Clear the form inputs
        setTitle('');
        setNote('');
    };

    const handleRemoveNote = (index) => {
        // Remove the note from the array by filtering it out
        const updatedNotes = eventNotes.filter((_, i) => i !== index);

        // Update local state to reflect the removed note
        setEventNotes(updatedNotes);

        const updatedEventData = {
            ...selectedEvent,
            Event_Notes: updatedNotes,
        };

        // Dispatch the action to update the event in the backend
        dispatch(UpdEvent({ id: selectedEvent.id, updatedEventData }));
    };
    const HandleBack = () => {
        navigate("/co-ordinator-dashboard/User-InQuiry");
      };
    return (
        <div id='AddNote' className='container mt-5'>
             <Button
                      variant="contained"
                      color="secondary"
                      onClick={HandleBack}
                      sx={{ position: "absolute", top: "20px", left: "20px" }}
                    >
                      Back
                    </Button>
            <div className='text-center'>
                <h1>Add Note</h1>
            </div>
            <div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Title:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Note:</label>
                        <textarea
                            className="form-control"
                            rows="5"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                        ></textarea>
                    </div>

                    <button type="submit" className="btn btn-primary mt-3">Submit</button>
                </form>
            </div>
            <div className='mt-5'>
                <h2 className='text-center mt-4'>Event Notes</h2>
                {eventNotes.length > 0 ? (
                    <div className="notes-section">
                        {eventNotes.map((note, index) => (
                            <div key={index} className="note">
                                <h6 className="note-title"><strong>{index + 1}. {note.title}</strong></h6>
                                <p className="note-text"><em>{note.note}</em></p>
                                <button onClick={() => handleRemoveNote(index)} className="btn btn-danger btn-sm">Remove</button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>No notes available for this event.</p>
                )}
            </div>
        </div>
    );
};

export default AddNote;
